export default "__VITE_ASSET__0Z1cjoFJ__"